import { createContext, useCallback, useContext } from 'react';
import { usePageHeaderStore } from 'stores/usePageHeaderStore';

/**
 * MDI 탭별 고정 mnuId 컨텍스트 (MainLayout에서 TabPanel마다 Provider로 공급)
 * - 값이 탭 생성 후 바뀌지 않으므로, 이 컨텍스트를 구독해도 탭 전환 시 리렌더가 발생하지 않음
 *   (MenuContext를 페이지에서 직접 구독하면 탭 전환마다 열린 모든 페이지가 리렌더됨)
 */
export const TabMnuIdContext = createContext<string>('');

/**
 * @desc 페이지 헤더 우측 부제목 설정 훅
 *
 * ex.
 * const { setSubTitle } = usePageSubTitle();
 * useEffect(() => setSubTitle(prjNm), [prjNm, setSubTitle]);
 * @author
 * -------------------------------------------------------------------------------------
 *  Date.       author         Description
 * -------------------------------------------------------------------------------------
 * 2026.09.12   jshwang12       신규 생성
 */
export const usePageSubTitle = () => {
  const mnuId = useContext(TabMnuIdContext);
  const setSubTitleByMenu = usePageHeaderStore((s) => s.setSubTitle);
  const clearSubTitleByMenu = usePageHeaderStore((s) => s.clearSubTitle);

  const setSubTitle = useCallback(
    (subTitle: string) => setSubTitleByMenu(mnuId, subTitle),
    [mnuId, setSubTitleByMenu]
  );
  const clearSubTitle = useCallback(() => clearSubTitleByMenu(mnuId), [mnuId, clearSubTitleByMenu]);

  return { setSubTitle, clearSubTitle };
};
